'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var debug = require('debug')('knack-field-predictor-core');
var predictors = require('./predictors');
var FieldPredictor = /*#__PURE__*/function () {
  function FieldPredictor() {
    _classCallCheck(this, FieldPredictor);
    debug('The following predictors were loaded:');
    debug(predictors);
  }
  return _createClass(FieldPredictor, [{
    key: "predict",
    value: function predict(value) {
      debug("Predicting type for value ".concat(value));
      var prediction;
      Object.keys(predictors).forEach(function (predictor_key) {
        if (prediction) {
          return;
        }
        var predictor_instance = new predictors[predictor_key]();
        debug("Attempting prediction via ".concat(predictor_instance.constructor.name));
        prediction = predictor_instance.predict(value);
      });
      return prediction;
    }
  }]);
}();
module.exports = new FieldPredictor();